export default "__VITE_ASSET__t3B90pEt__"